function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import dayjs from 'dayjs';
import { useEffect, useState, useRef } from 'react';

/**
 * 倒计时hooks
 * @param time 初始时间 时间戳
 * @param interval 时间间隔 默认120分钟
 * @param unit 时间间隔单位，默认minute
 * @return
 */

var numToString = function numToString(number) {
  // eslint-disable-next-line no-param-reassign
  number = String(number);
  if (number.length !== 1) return String(number);
  return "0".concat(number);
};
var timer;
var useCountDown = function useCountDown(options) {
  var _ref = options || {},
    time = _ref.time,
    _ref$interval = _ref.interval,
    interval = _ref$interval === void 0 ? 60 * 2 : _ref$interval,
    _ref$unit = _ref.unit,
    unit = _ref$unit === void 0 ? 'm' : _ref$unit;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    info = _useState2[0],
    setInfo = _useState2[1];
  var ref = useRef(0);
  var calculateTime = function calculateTime() {
    /** 创建时间 */
    var createDay = dayjs(time);
    /** 截至时间 */
    var endTime = createDay.add(interval, unit);
    /* 当前时间 */
    var nowTime = dayjs();
    /** 是否超时 */
    var isOver = endTime.isBefore(nowTime);
    var hour;
    var seconds;
    var min;
    var day;
    if (isOver) {
      day = '00';
      hour = '00';
      seconds = '00';
      min = '00';
      clearInterval(timer);
    } else {
      day = numToString(Math.floor(endTime.diff(nowTime, 'day', true)));
      hour = numToString(Math.floor(endTime.diff(nowTime, 'hour', true) % 24));
      min = numToString(Math.floor(endTime.diff(nowTime, 'minute', true) % 60));
      seconds = numToString(Math.floor(endTime.diff(nowTime, 'second', true) % 60));
    }
    setInfo(function () {
      return {
        day: day,
        hour: hour,
        min: min,
        seconds: seconds,
        isOver: isOver
      };
    });
    return isOver;
  };
  var init = function init() {
    // 初始化先走一次，避免1s延迟
    var isOver = calculateTime();
    // 如果时间已经过期的话，不走定时器
    if (isOver) return;
    timer = setInterval(function () {
      calculateTime();
    }, 1000);
  };
  useEffect(function () {
    if (!time || ref.current) return;
    ref.current = time;
    init();
    return function () {
      return clearInterval(timer);
    };
  }, [time]);
  return [info];
};
export default useCountDown;